const products = [
  {
    id: 1,
    name: "KIRCI VPN",
    tagline: "Secure. Private. Fast.",
    description:
      "A powerful VPN solution built for iOS that encrypts your internet connection, masks your IP address, and keeps your online activity completely private. Designed with a clean interface and military-grade encryption protocols.",
    features: ["AES-256 Encryption", "Zero-Log Policy", "Global Server Network", "One-Tap Connect"],
    image:
      "https://public.readdy.ai/ai/img_res/dfefdbf8240e978c7456374bc537a4dc.jpg",
    accent: "from-emerald-500/20 to-teal-500/10",
    iconColor: "text-emerald-500",
    icon: "ri-shield-keyhole-line",
  },
  {
    id: 2,
    name: "KIRCI Cleaner",
    tagline: "Clean. Optimize. Perform.",
    description:
      "An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary cache data to free up storage space and boost your device performance. Smart scanning technology identifies what's safe to remove.",
    features: ["Smart Junk Scan", "Duplicate Finder", "Memory Boost", "Storage Analyzer"],
    image:
      "https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20app%20interface%20on%20iPhone%2C%20clean%20white%20and%20light%20gray%20theme%20with%20sparkle%20and%20broom%20icon%2C%20abstract%20particles%20being%20swept%20away%2C%20minimalist%20premium%20design%2C%20soft%20light%20background%20with%20subtle%20orange%20accent%2C%20professional%20product%20photography%20style%2C%20no%20text%20overlay&width=600&height=700&seq=kirci-cleaner-product&orientation=portrait",
    accent: "from-orange-500/20 to-amber-500/10",
    iconColor: "text-orange-500",
    icon: "ri-sparkling-line",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 md:py-36 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium">What We Build</span>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mt-3 tracking-tight">
            Our Products
          </h2>
          <div className="w-12 h-px bg-gray-300 mx-auto mt-6" />
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {products.map((product) => (
            <article
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden group transition-transform duration-300 hover:-translate-y-1"
            >
              {/* Image */}
              <div className={`relative h-72 md:h-80 bg-gradient-to-br ${product.accent} overflow-hidden`}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top opacity-90 group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-8 md:p-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gray-50`}>
                    <i className={`${product.icon} ${product.iconColor} text-xl`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">{product.name}</h3>
                    <p className="text-sm text-gray-400 font-light">{product.tagline}</p>
                  </div>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-6">{product.description}</p>

                <ul className="grid grid-cols-2 gap-2">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-xs text-gray-500">
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0" />
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
